import { DecisionState } from '@/models/games/blackjack2/enums/DecisionState';
import {
    GameState as Blackjack2GameState,
    GameState,
} from '@/models/games/blackjack2/enums/GameState';
import { BetSeatIndex } from '@/models/games/blackjack2/SeatPlayerInfo';
import {
    getTableBetByHostId,
    tableBetSliceActions,
} from '@/modules/betTable/slice';
import { hostLiveSliceActions } from '@/modules/hostLive/slice';
import {
    bj2HandSliceActions,
    getSeatHands,
} from '@/modules/rwdGame/blackjack2/slice/handSlice';
import { bj2SeatSliceActions } from '@/modules/rwdGame/blackjack2/slice/seatSlice';
import { RootState } from '@/store/store';
import { Epic } from 'redux-observable';
import { concat, filter, switchMap } from 'rxjs';

export const updateCardOnlyEpic: Epic = (action$, store$) =>
    action$.pipe(
        filter(bj2HandSliceActions.updateCardsOnly.match),
        switchMap(action => {
            const outs = [];
            const store = store$.value as unknown as RootState;
            const hand = getSeatHands(store, action.payload.hostId);
            if (
                hand.GameState === Blackjack2GameState.Decision ||
                hand.GameState === Blackjack2GameState.FollowDecision
            ) {
                if (hand.ActionSeat >= 0) {
                    outs.push(
                        bj2SeatSliceActions.updateSeatObject({
                            hostId: action.payload.hostId,
                            seat: hand.ActionSeat,
                            DecisionState: DecisionState.NO_DECISION,
                        })
                    );
                }
            }
            return concat(outs);
        })
    );

export const updateHandsEpic: Epic = (action$, store$) =>
    action$.pipe(
        filter(bj2HandSliceActions.updateHands.match),
        switchMap(action => {
            const outs = [];
            const store = store$.value as unknown as RootState;
            const hand = getSeatHands(store, action.payload.hostId);
            if (action.payload.others.count_down > 0) {
                outs.push(
                    hostLiveSliceActions.updateCountDown({
                        hostId: action.payload.hostId,
                        countDown: action.payload.others.count_down * 1000,
                        remainTime: action.payload.others.remain_time,
                        canLeave: false,
                    })
                );
            }

            if (
                action.payload.infos.GameState ===
                    Blackjack2GameState.Started &&
                hand.GameState == Blackjack2GameState.BetTicketing
            ) {
                const { isBetConfirmed, GameId } = getTableBetByHostId(
                    store,
                    action.payload.hostId
                );
                if (!isBetConfirmed) {
                    outs.push(
                        tableBetSliceActions.clearPendingBets({
                            hostId: action.payload.hostId,
                            gameId: GameId,
                            startGame: true,
                        })
                    );
                }
            }

            const seats_info = action.payload.others.seats_info;
            for (let i = 1; i <= 7; i++) {
                let key = `Seat${i}` as BetSeatIndex;
                const tmp = hand[key]?.hand1?.allow_decision;
                let state = DecisionState.NO_DECISION;
                if (i == action.payload.infos.ActionSeat) {
                    if (
                        action.payload.infos.GameState ===
                        Blackjack2GameState.Decision
                    ) {
                        state = DecisionState.NOW_DECISION;
                    } else if (
                        action.payload.infos.GameState ===
                        Blackjack2GameState.FollowDecision
                    ) {
                        state = DecisionState.FOLLOW_DECISION;
                    } else {
                        state = DecisionState.NO_DECISION;
                    }
                } else if (action.payload.infos.ActionSeat == 0) {
                    state = DecisionState.NO_DECISION;
                } else if (i < action.payload.infos.ActionSeat) {
                    state = DecisionState.NO_DECISION;
                } else {
                    state = DecisionState.PRE_DECISION;
                }
                if (
                    !tmp ||
                    tmp.length == 0 ||
                    action.payload.others.state === GameState.Started ||
                    action.payload.others.state === GameState.BetTicketing ||
                    action.payload.others.state === GameState.Ready
                ) {
                    state = DecisionState.NO_DECISION;
                }
                const info = seats_info.find(v => v.seat_num == i);
                outs.push(
                    bj2SeatSliceActions.updateSeatObject({
                        hostId: action.payload.hostId,
                        seat: i,
                        DecisionState: state,
                        PreDecision: info ? info.predecision : 0,
                        IsSplit: info ? info.is_split == 1 : false,
                    })
                );
            }
            return concat(outs);
        })
    );
